import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate";
import { Popups } from "ui/types/popups";
import { BANNER_VERSION } from "..";

export const WhatsNew = () => {
    const handleButtonClick = () => {
        GameUI.closePopup(Popups.WHATS_NEW);
        (window as any)?.dataLayer?.push({
            event: "whats_new_banner_button",
            version: BANNER_VERSION,
        });
    }


    const handleDiscardBtnClick = () => {
        (window as any)?.dataLayer?.push({
            event: "whats_new_banner_not_now",
            version: BANNER_VERSION,
        });
        GameUI.closePopup(Popups.WHATS_NEW);
    }

    return (
        <div id="whats_new" role="tooltip" className="whats_new modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={() => GameUI.closePopup(Popups.WHATS_NEW)}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("whats_new_title")}</span>
                    <img className="modals_area_img" src="/assets/whats_new_popup/whats_new_3.webp?v=0.0.3" />
                    <p className="modals_area-text" style={{ maxWidth: '100%' }}>{translate("whats_new_text")}</p>
                    <div className="feedback_btn-wrap">
                        {/* <button type="button" className="discard_btn close" onClick={handleDiscardBtnClick}>{translate("discard_btn_text")}</button> */}
                        <button id="whats_new_btn_close" onClick={handleButtonClick} type="button" className="modals_area-btn">{translate("whats_new_btn")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
